import React, { useRef, useState } from "react";
import { MdOutlineUploadFile } from "react-icons/md";
import axios from "axios";
import Loader from "../Loader/Loader"; // Import your Loader component

const uploadCompanyLogo = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/v1/s3`,
      formData,
      {
        headers: {
          "Content-type": "multipart/form-data",
          Accept: "multipart/form-data",
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("tykoon_access")),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error uploading image:", error);
    return null;
  }
};

const FileDropper = ({ formik }) => {
  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState(formik.fileName || "");
  const [fileUrl, setFileUrl] = useState(formik.values.companyLogo);
  const [isLoading, setIsLoading] = useState(false);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileName(file.name); // Set file name
      setIsLoading(true); // Show loader
      const uploadedUrl = await uploadCompanyLogo(file);
      setIsLoading(false); // Hide loader
      if (uploadedUrl) {
        const file = event.target.files[0];
        if (file) {
          setFileName(file.name); // Set file name
          const fileUrl = URL.createObjectURL(file); // Create a URL for the dropped file

          setFileUrl(fileUrl); // Set the preview URL immediately
        }
        const fileUrl = uploadedUrl?.photos[0];
        formik.setFieldValue("companyLogo", fileUrl);
      } else {
        console.error("Failed to upload image");
      }
    }
  };

  return (
    <div>
      <label className="block mb-1 text-sm font-medium text-gray-900">
        Add Company Logo
      </label>
      <div
        className="relative flex flex-col justify-center w-full h-32 border-2 border-dashed border-orange-400 rounded-lg bg-orange-50 cursor-pointer hover:bg-orange-100"
        onClick={() => fileInputRef.current.click()}
      >
        {isLoading ? (
          <div className="m-auto">
            <Loader />
          </div>
        ) : fileUrl ? (
          <div className="flex justify-center items-center h-full">
            <img
              src={fileUrl}
              alt="Uploaded Logo"
              className="h-full object-contain rounded"
              onError={() => setFileUrl(null)} // Clear the image if URL is not valid
              style={{ display: fileUrl ? "block" : "none" }} // Hide the image if fileUrl is not valid
            />
          </div>
        ) : (
          <div className="flex gap-8">
            <MdOutlineUploadFile className="w-12 h-12 text-orange-500" />
            <div className="flex flex-col justify-center items-center">
              {!fileName ? (
                <>
                  <p>Click to upload.</p>
                  <p className="text-xs text-gray-500">
                    Upload your company logo here
                  </p>
                </>
              ) : (
                <p className="text-sm font-medium text-gray-700">{fileName}</p>
              )}
            </div>
          </div>
        )}
      </div>
      <input
        ref={fileInputRef}
        id="uploadLogo"
        name="companyLogo"
        type="file"
        className="hidden"
        accept="image/*"
        onChange={handleFileChange}
      />
      {formik.touched.companyLogo && formik.errors.companyLogo && (
        <p className="mt-1 text-xs text-red-500">{formik.errors.companyLogo}</p>
      )}
    </div>
  );
};

export default FileDropper;
